{
	"title": "Mijn account",
	"description": "Hoe jij inlogt op het beheer. Een passkey is het veiligst; je kunt ook een wachtwoord gebruiken, of allebei.",
	"open": "Mijn account",
	"passkeys": {
		"title": "Passkeys",
		"description": "Inloggen met je vingerafdruk, je gezicht of de pincode van je laptop of telefoon.",
		"none": "Je hebt nog geen passkey.",
		"name": "Passkey {{number}}",
		"synced": "Gesynchroniseerd tussen je apparaten",
		"device": "Op één apparaat",
		"column": {
			"passkey": "Passkey",
			"created": "Toegevoegd",
			"lastUsed": "Laatst gebruikt",
			"actions": "Acties"
		},
		"remove": {
			"button": "{{name}} verwijderen",
			"title": "Passkey verwijderen?",
			"description": "Met deze passkey kun je daarna niet meer inloggen. Browsers die ermee ingelogd zijn, worden uitgelogd.",
			"confirm": "Verwijderen"
		},
		"lastOne": "Dit is je enige manier van inloggen. Stel eerst een wachtwoord in of voeg een andere passkey toe."
	},
	"password": {
		"title": "Wachtwoord",
		"description": "Inloggen met je e-mailadres en wachtwoord. Op een nieuwe browser vragen we daarna een code uit je mail.",
		"set": "Je hebt een wachtwoord.",
		"notSet": "Je hebt nog geen wachtwoord.",
		"lastUsed": "Laatst gebruikt: {{when}}",
		"choose": "Wachtwoord instellen",
		"change": "Wachtwoord wijzigen",
		"current": "Huidig wachtwoord",
		"currentWrong": "Je huidige wachtwoord klopt niet.",
		"saved": "Je wachtwoord is opgeslagen.",
		"cancel": "Annuleren",
		"remove": {
			"button": "Wachtwoord verwijderen",
			"title": "Wachtwoord verwijderen?",
			"description": "Daarna log je alleen nog in met een passkey. Browsers die je onthouden voor de code, vergeten je.",
			"confirm": "Verwijderen"
		},
		"lastOne": "Je wachtwoord is je enige manier van inloggen. Voeg eerst een passkey toe."
	},
	"helpExample": {
		"addPasskey": {
			"animation": "Je klikt op Passkey toevoegen op dit apparaat, bevestigt met je vingerafdruk, en de nieuwe passkey staat in de lijst.",
			"browser": "Gebruik je vingerafdruk, je gezicht of je pincode om een passkey te maken.",
			"continue": "Doorgaan",
			"steps": {
				"add": "Klik op Passkey toevoegen op dit apparaat.",
				"confirm": "Je browser vraagt je vingerafdruk, gezicht of pincode. Bevestig.",
				"listed": "De nieuwe passkey staat in de lijst. Voortaan log je hiermee in op dit apparaat."
			}
		}
	},
	"help": {
		"account": {
			"title": "Mijn account",
			"area": "Mijn account",
			"short": "Hoe jij inlogt op het beheer: met een passkey, een wachtwoord of allebei. Het geldt alleen voor jouw account; elke medewerker regelt dat zelf.",
			"terms": ["account:passkeys", "account:password", "account:lastWayIn", "employee:employees"]
		},
		"passkeys": {
			"title": "Passkeys",
			"area": "Mijn account › Passkeys",
			"short": "Een passkey is het veiligst: er is geen wachtwoord dat kan uitlekken. Voeg er een toe op elk apparaat waarmee je werkt. Met de prullenbak haal je er een weg.",
			"choices": [
				{
					"name": "Gesynchroniseerd tussen je apparaten",
					"text": "De passkey staat in je Apple-, Google- of Microsoft-account en werkt ook op je andere apparaten."
				},
				{
					"name": "Op één apparaat",
					"text": "Hij werkt alleen op het apparaat waar je hem toevoegde."
				}
			],
			"warning": "Haal je een passkey weg, dan worden de browsers die ermee ingelogd zijn uitgelogd.",
			"terms": ["account:lastWayIn"]
		},
		"password": {
			"title": "Wachtwoord",
			"area": "Mijn account › Wachtwoord",
			"short": "Inloggen met je e-mailadres en een wachtwoord. Op een nieuwe browser vragen we daarna een code uit je mail. Wijzig je het, dan vul je eerst je huidige wachtwoord in.",
			"warning": "Verwijder je je wachtwoord, dan vergeet elke vertrouwde browser je. Je logt daarna alleen nog in met een passkey.",
			"terms": ["session:trustedBrowser", "account:lastWayIn"]
		},
		"lastWayIn": {
			"title": "Laatste manier van inloggen",
			"area": "Mijn account",
			"short": "Je houdt altijd minstens één manier om in te loggen. Is een passkey of je wachtwoord de enige, dan kun je die niet verwijderen: voeg eerst een andere toe.",
			"terms": ["account:passkeys", "account:password"]
		}
	}
}
